import * as Yup from "yup";
/* eslint-disable no-useless-escape */
const RetailValidation = (t, countryCode) => {
  return Yup.object().shape({
    given_name: Yup.string()
      .min(2, t("auth.givenName.validMessage"))
      .required(t("auth.givenName.validMessage")),
    family_name: Yup.string()
      .min(2, t("auth.familyName.validMessage"))
      .required(t("auth.familyName.validMessage")),
    password: Yup.string()
      .min(8)
      .required()
      .matches(/\p{Ll}/u)
      .matches(/[A-Z]/)
      .matches(/[0-9]/)
      .matches(/[\^$*.{}\[\]()?"!@#%&/\\,><':;|_~`=+\-]/),
    kvkk: Yup.boolean()
      .required()
      .oneOf([true], t("auth.kvkkPolicy.validMessage")),
    loyalty:
      countryCode === "TR"
        ? Yup.boolean()
            .required()
            .oneOf([true], t("auth.loyaltyPolicy.validMessage"))
        : Yup.boolean().notRequired(),
    phone_number: Yup.string()
      .required(t("auth.phoneNumber.validMessage"))
      .matches(
        countryCode === "TR"
          ? /^\(\d{3}\)\s\d{3}\s\d{4}$/ // (XXX) XXX XXXX
          : /^\d{13}$/, // 13 rakam
        t("auth.phoneNumber.validMessage")
      ),
  });
};
export default RetailValidation;
